(ns pfo.time
  (:require [cljs-time.core :as time-core :refer [year month day hour minute second milli date-time
                                                  before? after? plus]]
            [cljs-time.coerce :refer [to-date to-long]]
            [cljs-time.format :as fmt]
            [cljs-time.periodic :as tp]
            [pfo.util :as util]))

(def time-shift-millis (time-core/millis (if (exists? js/TIME_SHIFT) (/ js/TIME_SHIFT 1000000) 0)))

(def toffset (atom nil))

(defn instance-start-time [] (when (exists? js/INSTANCE_START_TIME) (util/parse-datetime js/INSTANCE_START_TIME)))

(defn now []
  (time-core/plus (time-core/now) time-shift-millis @toffset))

(defn now-js-date []
  (to-date (now)))

(defn now-millis []
  (to-long (now)))

(defn ceil
  [dt dt-fn]
  (let [floor (time-core/floor dt dt-fn)]
    (if (time-core/before? floor dt)
      (let [dt-fns [year month day hour minute second milli]]
        (apply date-time
               (let [values (mapv apply
                                  (concat (take-while (partial not= dt-fn) dt-fns) [dt-fn])
                                  (repeat [dt]))]
                 (conj (vec (butlast values)) (+ 1 (last values))))))
      dt)))

(defn is-time-within-window [atime base-time period]
  (let [instance-time (instance-start-time)]
    (and (before? atime (plus base-time period)) (if instance-time (after? base-time instance-time) true))))

(defn is-now-within-window [base-time period]
  (is-time-within-window (now) base-time period))

(def iso-formatter (fmt/formatter "yyyy-MM-dd'T'HH:mm:ss'Z'"))

(defn parse-date
  "Parses an ISO 8601 string into a cljs-time date-time object."
  [date-str]
  (fmt/parse iso-formatter date-str))

(defn expand-date-range
  "Expands a date range into a sequence of individual dates."
  [from-date to-date]
  (let [start (parse-date from-date)
        end (parse-date to-date)]
    (take-while #(time-core/before? % (time-core/plus end (time-core/days 1)))
                (iterate #(time-core/plus % (time-core/days 1)) start))))

(defn structure-by-year-month
  "Takes a list of date objects and structures them into {year -> {month -> [days]}}."
  [dates]
  (reduce (fn [acc date]
            (let [year  (time-core/year date)
                  month (time-core/month date)
                  day   (time-core/day date)]
              (update-in acc [year month] (fnil conj []) day)))
          {} dates))

(defn transform-date-ranges
  "Transforms a list of date range maps into a nested {year -> {month -> [days]}} structure."
  [date-ranges]
  (->> date-ranges
       (mapcat #(expand-date-range (:from_date %) (:to_date %)))
       structure-by-year-month))
